import validate from "/app/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.26_better-sq_0ee4151e24210ad74a1f5186a42a7e96/node_modules/nuxt/dist/pages/runtime/validate.js";
import trailing_45slash_45global from "/app/app/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.26_better-sq_0ee4151e24210ad74a1f5186a42a7e96/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authentication: () => import("/app/app/middleware/authentication.ts")
}